import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the challenge modal component.
 */
const useBattleshipModalStyles = makeStyles()(() => ({
  modalStyles: {
    'display': 'flex',
    'flexDirection': 'column',
    'justifyContent': 'center',
    'alignItems': 'center',
    'position': 'absolute',
    'top': '50%',
    'left': '50%',
    'transform': 'translate(-50%, -50%)',
    'width': '20vw',
    'minWidth': 'fit-content',
    'height': 'fit-content',
    'backgroundColor': colors.white,
    'padding': theme.padding.l,
    'borderRadius': theme.borderRadius.s,
    'border': 'none',
    'boxShadow': `2px 2px 5px 5px ${colors.gray['400']}`,
    '&:focus': {
      outline: 'none',
    },
  },
  titleText: {
    marginBottom: '20px',
  },
  playingAgainst: {
    marginBottom: '10px',
  },
  selfContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '10px',
  },
  youAre: {
    marginRight: '5px',
  },
  userIcon: {
    width: '20px',
    height: '20px',
  },
  status: {
    marginBottom: '10px',
  },
  quit: {
    'background': colors.red['500'],
    'marginTop': '25px',
    'border': 'none',
    '&:hover': {
      backgroundColor: colors.red['600'],
    },
    'width': '100px',
  },
  win: {
    'background': colors.green['500'],
    '&:hover': {
      backgroundColor: colors.green['600'],
    },
  },
  gridsContainer: {
    display: 'flex',
    width: '630px',
    justifyContent: 'space-between',
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonRows: {
    position: 'relative',
    display: 'flex',
    flex: '1',
    maxWidth: '300px',
    alignItems: 'center',
    background: 'lightblue',
  },
  buttonColumns: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    height: '300px',
  },
  overlay: {
    position: 'absolute',
    background: 'gray',
    opacity: 0.5,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
  },
  button: {
    width: '30px',
    height: '30px',
    border: 'none',
  },
  noBoat: {
    background: 'none',
  },
  oneBoat: {
    background: 'gray',
    borderRadius: '15px',
  },
  topBoat: {
    background: 'gray',
    borderRadius: '15px 15px 0px 0px',
  },
  bottomBoat: {
    background: 'gray',
    borderRadius: '0px 0px 15px 15px',
  },
  middleVertBoat: {
    background: 'gray',
  },
  leftEndBoat: {
    background: 'gray',
    borderRadius: '0px 15px 15px 0px',
  },
  rightEndBoat: {
    background: 'gray',
    borderRadius: '15px 0px 0px 15px',
  },
  middleHorBoat: {
    background: 'gray',
  },
  hitBySelf: {
    height: '20px',
    width: '20px',
    background: 'red',
    borderRadius: '10px',
    transform: 'translate(5px, 5px)',
    marginBottom: '10px',
  },
  hitByOpp: {
    background: 'red',
  },
  revealBoat: {
    background: 'green',
  },
  miss: {
    height: '20px',
    width: '20px',
    background: 'white',
    borderRadius: '10px',
    transform: 'translate(5px, 5px)',
    marginBottom: '10px',
  },
  unOcc: {
    'background': 'none',
    '&:hover': {
      background: theme.background.light,
      cursor: 'pointer',
    },
  },
}));

export default useBattleshipModalStyles;
